import React from 'react';
import { Component } from "react";
import { Button } from 'react-bootstrap';

class DownloadOdataFileButton extends Component {
        render() {
            return (
        <Button onClick={(e) => {
            let token = localStorage.getItem('_TOKEN_AUTH');
            var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
            var request = {
                requestUri: this.props.source,
                method: 'POST',
                headers: headers,
                data: null
            };
            window.odatajs.oData.request(
                request,
                (data, response) => {
                  let link = document.createElement("a");
                  link.download = this.props.file_name;
                  let blob = new Blob(data.value, { type: "application/xml" });
                  link.href = URL.createObjectURL(blob);
                  link.click();
                  URL.revokeObjectURL(link.href);
                },
                (error) => {
                    if(error.response.statusCode === 401){
                      window.location.href = "/login";
                    }
                    this.setState({
                      pending: false,
                      error
                  });
                }
            );
      }}>{this.props.title}</Button>
            );
    }
}

export default DownloadOdataFileButton;